var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcOp16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1468_13062)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1468_13062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#FF0420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6672 10.1248C5.1904 10.1248 4.8 10.0128 4.496 9.7888C4.1952 9.5616 4.0448 9.2352 4.0448 8.816C4.0448 8.7264 4.0544 8.6208 4.0736 8.4928C4.1248 8.2048 4.1984 7.8592 4.2944 7.4528C4.5664 6.352 5.2704 5.8016 6.4032 5.8016C6.7104 5.8016 6.9888 5.8528 7.232 5.9584C7.4752 6.0576 7.6672 6.2112 7.808 6.416C7.9488 6.6176 8.0192 6.8576 8.0192 7.136C8.0192 7.2192 8.0096 7.3248 7.9904 7.4528C7.9296 7.808 7.8592 8.1568 7.7728 8.4928C7.632 9.04 7.392 9.4528 7.0464 9.7248C6.704 9.9936 6.2432 10.1248 5.6672 10.1248ZM5.7536 9.2608C5.9776 9.2608 6.1664 9.1936 6.3232 9.0624C6.4832 8.9312 6.5984 8.7296 6.6656 8.4544C6.7584 8.0768 6.8288 7.7504 6.8768 7.4688C6.8928 7.3856 6.9024 7.2992 6.9024 7.2096C6.9024 6.8448 6.7136 6.6624 6.3328 6.6624C6.1088 6.6624 5.9168 6.7296 5.7568 6.8608C5.6 6.992 5.488 7.1936 5.4208 7.4688C5.3472 7.7376 5.2768 8.064 5.2032 8.4544C5.1872 8.5344 5.1776 8.6176 5.1776 8.7072C5.1744 9.0784 5.3696 9.2608 5.7536 9.2608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29758 10.0672C8.25278 10.0672 8.22078 10.0544 8.19518 10.0256C8.17598 9.9936 8.16958 9.9584 8.17598 9.9168L9.00478 6.0128C9.01118 5.968 9.03358 5.9328 9.07198 5.904C9.10718 5.8752 9.14558 5.8624 9.18718 5.8624H10.784C11.2288 5.8624 11.584 5.9552 11.8528 6.1376C12.1248 6.3232 12.2624 6.5888 12.2624 6.9376C12.2624 7.0368 12.2496 7.1424 12.2272 7.2512C12.128 7.712 11.9264 8.0512 11.6192 8.272C11.3184 8.4928 10.9056 8.6016 10.3808 8.6016H9.57118L9.29598 9.9168C9.28638 9.9616 9.26718 9.9968 9.22878 10.0256C9.19358 10.0544 9.15518 10.0672 9.11358 10.0672H8.29758ZM10.4224 7.7728C10.592 7.7728 10.736 7.728 10.8608 7.6352C10.9888 7.5424 11.072 7.4112 11.1136 7.2384C11.1264 7.1712 11.1328 7.1104 11.1328 7.0592C11.1328 6.944 11.0976 6.8544 11.0304 6.7936C10.9632 6.7296 10.8448 6.6976 10.6816 6.6976H9.96158L9.73438 7.7728H10.4224V7.7728Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1468_13062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1468_13062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOp16);
export default __webpack_public_path__ + "static/media/ic_op_16.72fa253585a66aca3c48a0a8a67af041.svg";
export { ForwardRef as ReactComponent };